export const sortLocationsByName = (array: any[]) => {
  return array ? array?.sort((a: any, b: any) => a.title.localeCompare(b.title, 'en-US-u-kn-true')) : [];
};
